import React from "react";
import { TextField as MuiTextField } from "@mui/material";

const TextField = ({ onChange, ...otherProps }) => (
  <MuiTextField
    variant="standard"
    fullWidth
    onChange={(e) => {
      onChange(e.target.value);
    }}
    {...otherProps}
  />
);

export default TextField;
